<script>
  /**
   * The TingThings mark — a three-star sparkle cluster.
   *
   * Inline SVG rather than an <img> so it inherits `currentColor` and stays
   * crisp at any size. This is the same geometry the icon generator traces
   * (scriptpack/logo-assets/source/tingthings-sparkle.svg) — if you change one,
   * change both.
   */
  let { size = 28, class: klass = "" } = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={klass}
  aria-hidden="true">
  <!-- large four-point star -->
  <path
    d="M38 8c1.6 9.4 4.2 12 13.6 13.6C42.2 23.2 39.6 25.8 38 35.2 36.4 25.8 33.8 23.2 24.4 21.6 33.8 20 36.4 17.4 38 8Z"
    fill="currentColor" />
  <!-- medium star -->
  <path
    d="M19 26c1.1 6.4 2.9 8.2 9.3 9.3C21.9 36.4 20.1 38.2 19 44.6 17.9 38.2 16.1 36.4 9.7 35.3 16.1 34.2 17.9 32.4 19 26Z"
    fill="currentColor"
    opacity="0.85" />
  <!-- small star -->
  <path
    d="M40 42c.7 4.2 1.9 5.4 6.1 6.1-4.2.7-5.4 1.9-6.1 6.1-.7-4.2-1.9-5.4-6.1-6.1 4.2-.7 5.4-1.9 6.1-6.1Z"
    fill="currentColor"
    opacity="0.7" />
</svg>
